export const AppSettings = {
  apiBaseUrl: "http://192.168.213.248:3000/",
  defaultLanguage: "sl",
  languages: [
    {
      code: "sl",
      name: "Slovenščina",
    },
    {
      code: "en",
      name: "English",
    },
  ],
};
